<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- 列1：热门产品 -->
      <div class="footer-column">
        <h4>热门产品</h4>
        <ul>
          <li><router-link to="/product/audit-management">数字化审计系统</router-link></li>
          <li><router-link to="/product/enterprise-risk-management">风险管理系统</router-link></li>
          <li><router-link to="/product/audit-supervision">领导干部评价画像</router-link></li>
          <li><router-link to="/product/audit-data-model">大数据审计模型</router-link></li>
          <li><router-link to="/product/ai-audit">人工智能审计</router-link></li>
        </ul>
      </div>
      <!-- 列2：咨询方案 -->
      <div class="footer-column">
        <h4>咨询方案</h4>
        <ul>
          <li><router-link to="/consulting/data-governance">数据治理</router-link></li>
          <li><router-link to="/consulting/digital-transformation">数字化转型</router-link></li>
          <li><router-link to="/consulting/audit-risk-consulting">审计风控合规</router-link></li>
          <li><router-link to="/consulting">内控咨询</router-link></li>
          <li><router-link to="/consulting/ai-consulting">AI及大模型咨询</router-link></li>
        </ul>
      </div>
      <!-- 列3：培训方案 -->
      <div class="footer-column">
        <h4>培训方案</h4>
        <ul>
          <li><router-link to="/training/data-analysis">财务数据分析与应用实践</router-link></li>
          <li><router-link to="/training/data-management">供应链数据分析与应用实践</router-link></li>
          <li><router-link to="/training/ai-practical">AI及大模型应用实践</router-link></li>
          <li><router-link to="/training/cdo">首席数据官CDO（实践班）培训</router-link></li>
          <li><router-link to="/training/all-courses">2026年全年培训计划</router-link></li>
        </ul>
      </div>
      <!-- 列4：关于我们 -->
      <div class="footer-column">
        <h4>关于我们</h4>
        <ul>
          <li><router-link to="/about#about">古杉简介</router-link></li>
          <li><router-link to="/about#timeline">大事记</router-link></li>
          <li><router-link to="/about#certificate">权威资质</router-link></li>
          <li><router-link to="/about#honors">品牌荣誉</router-link></li>
          <li><router-link to="/about#media">媒体报道</router-link></li>
          <li><router-link to="/about#contact">联系我们</router-link></li>
        </ul>
      </div>

      <!-- 列5：双二维码及联系方式 -->
      <div class="footer-column footer-contact">
          <div class="qr-intro">
              关注公众号北京古杉数据官网、或数据社区《数据决策与数字化转型》公众号，随时获取一手实践资料、社区定期全国有线上/线下专业沙龙活动。
          </div>
          <div class="qr-row">
              <div class="qrcode-dual">
                  <div class="qr-text">古杉数据官方号</div>
                  <div class="qr-placeholder">
                      <img src="@/assets/img/gzh_guanwang.jpg" alt="古杉数据官方号" />
                  </div>
                  <div class="qr-hint">扫一扫关注</div>
              </div>

              <div class="qrcode-dual">
                  <div class="qr-text">数据社区官方号</div>
                  <div class="qr-placeholder">
                      <img src="@/assets/img/gzh_shujushequ.jpg" alt="数据社区官方号" />
                  </div>
                  <div class="qr-hint">扫一扫关注</div>
              </div>

<!--

              <div class="qrcode-dual">
                  <div class="qr-text">数据社区</div>
                  <div class="qr-placeholder">
                      <i class="fas fa-weixin"></i>
                  </div>
                  <div class="qr-hint">扫一扫关注</div>
              </div>           

-->
          </div>
          <div class="contact-info">
              <p><i class="fas fa-phone-alt"></i> 产品咨询：18510176330</p>
              <p><i class="fas fa-envelope"></i> 市场合作：pmo@gushandata.cn</p>
          </div>
      </div>


    </div>
    <div class="footer-bottom">
      © 2026 古杉咨询. All rights reserved. 	京ICP备2020035214号-2
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --primary-blue: #1F3F8F;
  --deep-indigo: #0E1F52;
  --light-porcelain: #EAF0FB;
  --bg-light: #f5f7fa;
  --text-dark: #2B2F3A;
  --footer-bg: #0E1F52;
  --footer-text: #ffffff;
  --footer-link-hover: #EAF0FB;
  --footer-border: rgba(255,255,255,0.1);
}

.footer {
  /* 青花瓷：#0E1F52     备选：#1F3F8F */
  background-color: #1F3F8F;
  color: white;
  padding: 35px 0 30px;
  font-size: 14px;
  line-height: 1.7;
  border-top: 1px solid rgba(255,255,255,0.05);
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: grid;
  /* 优化：左侧四列均分，右侧列稍宽(1.6fr) 使比例更协调 */
  grid-template-columns: repeat(4, 1fr) 1.6fr;
  gap: 30px;
}

.footer-column h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: white;
  letter-spacing: 0.5px;
  position: relative;
  padding-bottom: 8px;
}

.footer-column h4::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 2px;
  background-color: var(--primary-blue);
  border-radius: 2px;
}

.footer-column ul {
  list-style: none;
  padding: 0;
}

.footer-column li {
  margin-bottom: 10px;
}

.footer-column a {
  color: rgba(255,255,255,0.8);
  text-decoration: none;
  transition: color 0.2s ease;
  font-size: 14px;
}

.footer-column a:hover {
  color: var(--footer-link-hover);
  text-decoration: underline;
}

 /* 右侧列 (联系方式与二维码) */
.footer-contact {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.qr-intro {
    font-size: 13px;
    line-height: 1.5;
    color: rgba(255,255,255,0.7);
    margin-bottom: 8px;
}
.qr-row {
    display: flex;
    gap: 12px;
    justify-content: space-between;
}
.qrcode-dual {
    flex: 1;
    background: white;
    border-radius: 12px;
    padding: 14px 6px;
    text-align: center;
    color: var(--deep-indigo);
    box-shadow: 0 8px 16px rgba(0,0,0,0.2);
    transition: transform 0.2s;
}
.qrcode-dual:hover {
    transform: translateY(-2px);
}
.qrcode-dual .qr-text {
    font-size: 12px;
    font-weight: 500;
    color: var(--deep-indigo);
    margin-bottom: 6px;
}
.qr-placeholder {
    width: 110px;
    height: 110px;
    background: #e9eef4;
    margin: 6px auto;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #d0d9e8;
    overflow: hidden;
}
.qr-placeholder img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
    display: block;
}
.qr-hint {
    font-size: 10px;
    color: #5f6a7d;
}
.contact-info p {
    margin-bottom: 8px;
    color: rgba(255,255,255,0.9);
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 8px;
}
.contact-info i {
    width: 18px;
    color: var(--light-porcelain);
}
.footer-bottom {
    max-width: 1200px;
    margin: 10px auto 0;
    padding: 20px 24px 0;
    border-top: 1px solid var(--footer-border);
    text-align: center;
    font-size: 13px;
    color: rgba(255,255,255,0.6);
}

/* 响应式 */
@media (max-width: 992px) {
    .footer-container {
        grid-template-columns: repeat(3, 1fr);
    }
}
@media (max-width: 768px) {
    .footer-container {
        grid-template-columns: repeat(2, 1fr);
    }
    .qr-row {
        flex-direction: column;
        gap: 16px;
    }
}
@media (max-width: 480px) {
    .footer-container {
        grid-template-columns: 1fr;
    }
}

</style>
